export interface ResultsReducerState {
}

interface Payload {

}

interface Action {
    type: string;
    payload: Payload;
}

const initialState = { };

const resultsReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        default:
            return {
                ...state
            };
    }
};

export default resultsReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/resultsReducer.ts